// extracted by mini-css-extract-plugin
export default {"helpMenuItem":"HelpMenuItem_helpMenuItem__H6mMF","icon":"HelpMenuItem_icon__cKKiN","label":"HelpMenuItem_label__4c1oc","subLabel":"HelpMenuItem_subLabel__LI9nL"};